import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** Resolved HTML for the portal home main message from API when week-specific copy exists (ICPPPD-6554). Not persisted. */
export type HomepageState = {
  mainMessageHtml: string | undefined;
};

const initialState: HomepageState = {
  mainMessageHtml: undefined,
};

const homepageSlice = createSlice({
  name: "homepage",
  initialState,
  reducers: {
    setHomepageMainMessageHtml(state, action: PayloadAction<string | undefined>) {
      state.mainMessageHtml = action.payload;
    },
    clearHomepageMainMessageHtml(state) {
      state.mainMessageHtml = undefined;
    },
  },
});

export const { setHomepageMainMessageHtml, clearHomepageMainMessageHtml } =
  homepageSlice.actions;

export default homepageSlice.reducer;
